import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { PromotionsScreen } from './PromotionsScreen';
import type { PromotionsSearch } from './promotions-search';

const route = getRouteApi('/promotions');

export function PromotionsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: PromotionsSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  const onOpenCampaign = useCallback(
    (id: string) => {
      void navigate({ to: '/promotions/$campaignId', params: { campaignId: id }, search: {} });
    },
    [navigate],
  );

  return <PromotionsScreen search={search} onSearchChange={onSearchChange} onOpenCampaign={onOpenCampaign} />;
}
